'use client';

import { motion } from 'framer-motion';
import Link from 'next/link';
import { useLocalePath } from '@/i18n/LangContext';

// Definiere den CTA-Typ direkt
interface CtaData {
  title: string;
  desc: string;
  button: string;
}

interface CtaSectionProps {
  cta: CtaData;  // Verwendung des eigenständigen Typs
}

export function CtaSection({ cta }: CtaSectionProps) {
  const lp = useLocalePath();
  return (
    <motion.div
      className="text-center"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 1.8 }}
    >
      <h2 className="text-2xl font-bold mb-4">{cta.title}</h2>
      <p className="text-white/70 mb-8 max-w-lg mx-auto">
        {cta.desc}
      </p>
      <Link href={lp('/contact')}>
        <motion.button
          className="px-8 py-4 rounded-lg bg-[#0C0B32] text-[#88ffff] border border-[#88ffff]/30 font-medium"
          whileHover={{
            scale: 1.05,
            backgroundColor: 'rgba(15, 15, 70, 1)'
          }}
          whileTap={{ scale: 0.97 }}
        >
          {cta.button}
        </motion.button>
      </Link>
    </motion.div>
  );
}